import { styles } from 'consts';
import styled from 'styled-components';

const { modalButton, paymentColor, bluePrimary, fontMontserrat } = styles;

interface ContainerProps {
  isValid: boolean;
}

export const Container = styled.div.attrs<ContainerProps>(({ isValid }) => ({
  style: {
    height: isValid ? '15.1875rem' : '18.1875rem',
  },
}))<ContainerProps>`
  width: 17.5rem;
  margin: 0.5rem auto 0.5rem;
  box-sizing: border-box;

  @media (min-width: 768px) {
    margin: 1.5rem auto;
  }

  input {
    outline: none;
    height: 1.5rem;
    font-family: ${fontMontserrat};
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.1625rem;
    line-height: 1.5rem;
    border: none;
    background: none;
    color: ${paymentColor};

    &:focus {
      caret-color: ${bluePrimary};
    }
  }

  input::placeholder {
    color: ${modalButton};
    outline: none;
    border: none;
  }

  #cc-exp {
    position: absolute;
    display: none;
  }
`;

export const ErrorContainer = styled.div`
  height: 1.25rem;
  font-family: ${fontMontserrat};
  font-size: 0.75rem;
  line-height: 1.25rem;
  color: red;
  margin-top: -2.5rem;
  text-align: center;
`;

export const BMCardFrame = styled.iframe`
  border: none;
`;
